module.exports = __webpack_public_path__ + "img/tokkuri_ico.9fe6c91a.png";